import './Price.scss'
import { t } from 'i18next'

import CustomRangeSlider from '../RangeSlider/RangeSlider'

function Price() {
  return (
    <div className="price">
      <p className="priceLabel">{t('price')}</p>
      <CustomRangeSlider
        attribute="category.minPrice"
        title="filterDevicePrice"
        idCustom="Device"
        id="Device"
      />
    </div>
  )
}

export default Price
